module.exports = __webpack_public_path__ + "static/media/keyiocn-smart-decisions.f2bdb288.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feature/keyiocn-smart-decisions.png
// module id = 89
// module chunks = 0